import React from 'react';
import { AlertCircleIcon, ClockIcon } from 'lucide-react';
export const TasksWidget = () => {
  const tasks = [{
    id: 1,
    title: 'Review Business License Application #BL-2023-0542',
    deadline: 'Today',
    priority: 'high',
    type: 'Business License'
  }, {
    id: 2,
    title: 'Approve Property Tax Exemption Request #PTX-2023-1187',
    deadline: 'Today',
    priority: 'high',
    type: 'Tax & Revenue'
  }, {
    id: 3,
    title: 'Inspect Building Permit Site #BP-2023-0823',
    deadline: 'Tomorrow',
    priority: 'medium',
    type: 'Land & Property'
  }, {
    id: 4,
    title: 'Resolve Water Connection Issue #WS-2023-0314',
    deadline: 'In 2 days',
    priority: 'medium',
    type: 'Water & Sanitation'
  }, {
    id: 5,
    title: 'Review Public Event Permit #EVT-2023-0097',
    deadline: 'In 3 days',
    priority: 'low',
    type: 'Public Safety'
  }];
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-2115">
      <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center" data-id="element-2116">
        <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-2117">
          <AlertCircleIcon className="h-5 w-5 text-red-500 mr-2" data-id="element-2118" />
          Your Action Items
        </h2>
        <span className="bg-red-100 text-red-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-2119">
          5 Pending
        </span>
      </div>
      <div className="divide-y divide-gray-200" data-id="element-2120">
        {tasks.map(task => <div key={task.id} className="px-6 py-4 hover:bg-gray-50 cursor-pointer" data-id="element-2121">
            <div className="flex items-start" data-id="element-2122">
              <div className="flex-1" data-id="element-2123">
                <p className="text-sm font-medium text-gray-900" data-id="element-2124">
                  {task.title}
                </p>
                <div className="flex items-center mt-1" data-id="element-2125">
                  <ClockIcon className="h-4 w-4 text-gray-400 mr-1" data-id="element-2126" />
                  <span className={`text-xs ${task.priority === 'high' ? 'text-red-600' : task.priority === 'medium' ? 'text-orange-600' : 'text-blue-600'}`} data-id="element-2127">
                    Due {task.deadline}
                  </span>
                  <span className="mx-2 text-gray-300" data-id="element-2128">•</span>
                  <span className="text-xs text-gray-500" data-id="element-2129">{task.type}</span>
                </div>
              </div>
              <div data-id="element-2130">
                <span className={`inline-flex rounded-full h-2 w-2 ${task.priority === 'high' ? 'bg-red-500' : task.priority === 'medium' ? 'bg-orange-500' : 'bg-blue-500'}`} data-id="element-2131"></span>
              </div>
            </div>
          </div>)}
      </div>
      <div className="px-6 py-3 bg-gray-50 border-t border-gray-200" data-id="element-2132">
        <a href="#" className="text-sm font-medium text-blue-600 hover:text-blue-800" data-id="element-2133">
          View all tasks
        </a>
      </div>
    </div>;
};